export default __webpack_public_path__ + "static/media/paging_first.345e3fd3.svg";